<script lang="ts" setup>
const props = defineProps<{ mount?: boolean }>()
const [isOpen, toggle] = useToggle(props.mount ?? false)

onMounted(() => {
  props.mount && (isOpen.value = false)
})

</script>

<template>
  <slot v-if="$slots.button" name="button" v-bind="{ toggle }">
  </slot>
  <button v-else-if="$slots.trigger" @click="toggle()">
    <slot name="trigger"></slot>
  </button>
  <!--  -->
  <el-drawer class=" a-drawer" v-model="isOpen" v-bind="$attrs">
    <template v-for="(v, k) in $slots" :key="k" v-slot:[k]>
      <slot :name="k" v-bind="{ isOpen, toggle }"></slot>
    </template>
    <slot v-bind="{ isOpen, toggle }"></slot>
  </el-drawer>
</template>

<style lang="scss">
.a-drawer {

  .el-drawer__header,
  .el-drawer__body,
  .el-drawer__footer {
    padding: 0;
    margin: 0;
  }

  .el-drawer__close-btn {
    position: absolute;
    right: 20px;
  }

  .el-drawer__close {
    color: #000000e6;
    font-size: 24px;
  }
}
</style>
